import { render, staticRenderFns } from "./OrganisationForm.vue?vue&type=template&id=49addf9c&scoped=true&"
import script from "./OrganisationForm.vue?vue&type=script&lang=js&"
export * from "./OrganisationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49addf9c",
  null
  
)

export default component.exports